import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  HeroPanel,
  DetailTilesContainer,
  EnvironmentTitle,
  BannerTilesGroup,
  BannerStatusTile,
  getOpenRepoCashAndNotionalAmounts,
  BannerCurrencyTotalTilesContainer
} from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Translation, Locale } from 'locale'
import { DealDetail, UserPreference } from 'api'
import { createUserPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { BannerCurrencyTotalTile } from 'view/shared/heroPanel/BannerCurrencyTotalTile'

interface OpenReposHeroPanelProps {
  dealDetails: DealDetail[]
  userPreference: UserPreference
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({
  userPreference: createUserPreferenceSelector()
})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/openRepos')
}

const OpenReposHeroPanelComponent: React.FC<OpenReposHeroPanelProps> = props => {
  const { onTearout, dealDetails, userPreference } = props
  const cashAndNotionalAmounts = getOpenRepoCashAndNotionalAmounts(dealDetails)

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'OpenReposHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_OPEN_REPO)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_STATUS)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_SECTION_OPEN_REPO)} label={dealDetails.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>

      <BannerCurrencyTotalTilesContainer>
        {cashAndNotionalAmounts.map((cashAndNotionalAmount, key) => (
          <BannerCurrencyTotalTile key={key} cashAndNotionalAmount={cashAndNotionalAmount} userPreference={userPreference} />
        ))}
      </BannerCurrencyTotalTilesContainer>
    </HeroPanel>
  )
}

export const OpenReposHeroPanel = connect(mapStateToProps, mapDispatchToProps)(OpenReposHeroPanelComponent)
